import React from "react";
import Navigation from "../../../components/Navigation";

const PDFView = ({ PDF }) => {

  return (
    <div>
      <Navigation title="Guide" appBarColor="orange" />
      {/* <iframe
            className="h-screen w-full"
            src={location?.state?.pdfLink}
            title="myFrame"
          ></iframe> */}
    </div>
  );
};

export default PDFView;
